import { store } from '@store/online/index';
import config from '../../config/configuration';
import { getVisibilityParams, removeEmptyKeys } from '../../utils/UtilFunctions';
import { endpoints } from '../core/apiConfig';
import client from '../core/Interceptor';
import { FilteredItemsParams, QueryParams } from './menu.type';

//const token = getCookie('AccessToken')

export const getMenu = async () => {
  const response = await fetch(`${config.BASE_URL}${endpoints.menu.getMenuUrl}/2`, { cache: 'no-store' }); //hard-coded the menu id since we don't have menus to choose from for now
  return response.json();
};
// export const getRecommendedItems = async (limit: number, minOrders: number) => {
//   const response = await client.get(`${endpoints.menu.getPopularItems}?limit=${limit}&minimumOrders=${minOrders}`);

export const getRecommendedItems = async (
  restaurantId: number,
  itemIds: number[] = [],
  limit = 5,
  minOrders = 1,
  menuId?: number
) => {
  const orderType = store.getState().restaurant.orderType;
  const visibilityParams = getVisibilityParams();
  const newObj = removeEmptyKeys({
    ...visibilityParams,
    restaurantId: JSON.stringify(restaurantId),
    limit: JSON.stringify(limit),
    minimumOrders: JSON.stringify(minOrders),
    ...(menuId && { menuId: JSON.stringify(menuId) }),
    itemIds,
    orderType,
  });
  const response = await client.get(`${endpoints.menu.getPopularItems}`, {
    params: newObj,
  });
  return response.data;
};

export const getFavoriteMenuItems = async (restaurantId: number, limit = 4) => {
  const response = await client.get(`${endpoints.menu.getFavoriteItems}/?restaurantId=${restaurantId}&limit=${limit}`);
  return response.data;
};

export const getTags = async (restaurantId: number, menuId: number) => {
  const response = await client.get(`${endpoints.menu.getTags}?restaurantId=${restaurantId}&menuId=${menuId}`);
  return response.data;
};
export const getAllergens = async (restaurantId: number, menuId: number) => {
  const response = await client.get(`${endpoints.menu.getAllergens}?restaurantId=${restaurantId}&menuId=${menuId}`);
  return response.data;
};
export const getFilteredItems = async (params: FilteredItemsParams, restaurantId: number, userId?: string) => {
  const visibilityParams = getVisibilityParams();

  const {
    menuId,
    categoryId,
    isFavorite,
    isPopular,
    keywords,
    selectedAllergens,
    selectedTags,
    minPrice,
    maxPrice,
    maxPrepTime,
    minPrepTime,
    hideOutOfStockItems,
    orderType,
  } = params;
  const queryParams = {
    restaurantId,
    menuId,
    categoryId,
    isFavorite,
    isPopular,
    keywords,
    allergens: selectedAllergens,
    tags: selectedTags,
    maximumPrice: maxPrice,
    minimumPrice: minPrice,
    maximumPreparationTime: maxPrepTime,
    minimumPreparationTime: minPrepTime,
    hideOutOfStockItems: hideOutOfStockItems,
    orderType,
    ...visibilityParams,
  };

  Object.keys(queryParams).forEach(
    (key) => queryParams[key as keyof QueryParams] == null && delete queryParams[key as keyof QueryParams]
  );
  const response = await client.get(`${endpoints.menu.getSearchItems}?userId=${userId}`, {
    params: queryParams,
  });

  return response.data;
};

export const getReviews = async (id: number, restaurantId: number) => {
  const response = await client.get(`${endpoints.feedback.reviews}/${id}?restaurantId=${restaurantId}`);
  return response.data;
};

export const getMenuVersion = async (restaurantId: number, businessId: number) => {
  const response = await client.get(
    `${endpoints.menu.validateMenuVersion}?restaurantId=${restaurantId}&businessId=${businessId}`
  );
  return response?.data?.data ?? null;
};

export const getAllMenuData = async (restaurantId: number, businessId: number) => {
  const response = await client.get(
    `${endpoints.menu.getCompleteMenu}?restaurantId=${restaurantId}&businessId=${businessId}`
  );
  return response?.data?.data ?? null;
};
